/* eslint-disable security/detect-object-injection */
import { useValidation } from '@xengage/gw-portals-validation-react';
import {
    ViewModelForm,
    withViewModelService,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import React, { useCallback } from 'react';
import _ from 'lodash';
import './PersonalPage.messages';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import metadata from './PersonalPage.metadata.json5';
import ProductandcoveragesselectionComponent from "../../components/CyberLiabilityPersonal/Productandcoveragesselection/ProductandcoveragesselectionComponent"
import RiskInformationComponent from "../../components/CyberLiabilityPersonal/RiskInformation/RiskInformationComponent"

function PersonalPage(props) {
    const { wizardData: submissionVM, updateWizardData } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const pathToUpdate = 'lobData.cybLiaLine.coverables.personalCoverable'
    const {
        onValidate,
        initialValidation
    } = useValidation('CommercialPage');

    const onNext = useCallback(async () => {

        const productCode = _.get(submissionVM.value, 'baseData.productCode');
        const lobLineName = productCode ? lineName[productCode] : '';
        const response = await updateSubmission(lobLineName, 'CommercialPage', submissionVM);

        submissionVM.value = response;

        return submissionVM;
    }, [lineName, submissionVM, updateSubmission]);

    const onSave = useCallback(async () => {
        const subVMCopy = _.clone(submissionVM);
        const productCode = _.get(subVMCopy.value, 'baseData.productCode');

        validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.cybLiaLine?.coverables?.personalCoverable?.value, ' ');
        
        const lobLineName = productCode ? lineName[productCode] : '';
        await updateSubmission(lobLineName, 'PersonalPage', subVMCopy);

        return submissionVM;
    }, [submissionVM]);


    const overrideProps = {
        ProductandcoveragesselectionComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.productAndCoverageSelection`
        },
        RiskInformationComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathToUpdate}.riskInformation`
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            ProductandcoveragesselectionComponent,
            RiskInformationComponent
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const isDisableNext = () => !submissionVM.lobData.cybLiaLine.coverables.personalCoverable.aspects.subtreeValid

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            onNext={onNext}
            onSave={onSave}
        >
            <div>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    onModelChange={updateWizardData}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    overrideProps={overrideProps}
                    onValidationChange={onValidate}
                    resolveValue={readValue}
                />
            </div>
        </WizardPage>
    );
}

PersonalPage.propTypes = wizardProps;
export default withViewModelService(PersonalPage);
